import React, {useEffect, useState} from "react";
import {DateRangePicker} from "materialui-daterange-picker";
import { format } from 'date-fns'
import {useTranslation} from "react-i18next";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles(() => ({
	search: {
	    marginTop: 16
	}
}));

export const DateRangeFilter = ({onChange, value}) => {
  const [open, setOpen] = useState(false);
  const [initialValue, setInitialValue] = useState(value);
  const [dateRange, setDateRange] = useState(value);
  const classes = useStyles();

  useEffect(() => {
      setOpen(false);
      if (JSON.stringify(initialValue) != JSON.stringify(dateRange)) {
          if (onChange) {
              onChange(dateRange);
          }
      }
  }, [dateRange]);

  const toggle = () => setOpen(!open);
  const {t}  = useTranslation();

  const formatRange = (range) => {
      return format(range.startDate, 'yyyy-MM-dd') + " - " +  format(range.endDate, 'yyyy-MM-dd');
  }

  return (
      <div>
          <Grid item xs={12} className={classes.search}>
              <TextField onClick={e => setOpen(true)}
                value={dateRange ? formatRange(dateRange) : t('Choose date')} aria-readonly={true} onChange={e => {}}
              /></Grid>
          <div style={{position: "absolute"}}>

          <DateRangePicker
                  open={open}
                  toggle={toggle}
                  onChange={(range) => setDateRange(range)}
                />
          </div>
      </div>

  );
}